import { Component, Inject, OnInit, ChangeDetectorRef, ElementRef, ViewChild, NgZone } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { BehaviorSubject, Subscription, Observable, Observer } from 'rxjs';
import { RequestService, LayoutUtilsService, LoaderService } from '../../services';
import { urlSafeBase64Encoding } from '../../helpers';
import { ImageCroppedEvent, ImageCropperComponent } from 'ngx-image-cropper';
import { environment } from '../../../../environments/environment';

interface ViewDialogData {
	title: string;
	data: any;
	currentImage: string;
	profile: boolean;
	cameras: any;
}

@Component({
	selector: 'app-image-crop-plate-dialog-modal',
	templateUrl: './upload-image-crop-plate-dialog.component.html',
	styleUrls: ['./upload-image-crop-plate-dialog.component.scss']
})
export class ModalCropPlateRecognitionDialogComponent implements OnInit {
	private subscriptions: Subscription[] = [];
	public orgType = environment.orgType;
	public originalImage = undefined;
	public selectedUser: any;
	public errorMessage: string = '';
	public targetUserId: string = undefined;
	public passingThru: boolean = false;
	public loading: boolean = false;
	public hasFormErrors: boolean = false;
	public dataTypeDisplay: string = 'Image';
	public dataTypeSingleDisplay: string = 'Image';
	public dataTypeDisplayFolder: string = 'Folder';
	public dataList: any[] = [];
	public dataListFolder: any[] = [];
	public imageSelected: any = undefined;
	public imageUrlPath: any = undefined;
	public selectedRatio: number = 1;
	public folderText: string = '';
	public folderSelected: string = '';
	public tabSelected: number = 0;
	public searchVal: string = '';
	public imageChangedEvent: any = '';
	public croppedImage: any = '';
	// public allowedExtensions: string[] = ['jpeg', 'jpg', 'bmp', 'png', 'mp4'];
	public allowedExtensions: string[] = ['jpeg', 'jpg', 'bmp', 'png'];
	public isVideo: boolean = false;
	public uploadingVideo: boolean = false;
	public isEmpty: boolean = false;
	public plateRecognitionResults: any = undefined;
	public plateImageUrl: string = undefined;

	public pictureLink: string = undefined;
	public videoLink: any = undefined;
	public videoFileData: any = undefined;

	public paginatorTotal: BehaviorSubject<number> = new BehaviorSubject<number>(0);
	pageSize = 10;
	pageNumber = 1;

	orderDir = 'asc';
	orderBy = '_id'; // uid
	selectedCamera: string = undefined;
	public cameras: any = [];

	@ViewChild(ImageCropperComponent) imageCropper: ImageCropperComponent;
	@ViewChild('imageInput') imageInput: ElementRef;

	constructor(private zone: NgZone, private translate: TranslateService,
		private requestService: RequestService,
		private cdr: ChangeDetectorRef, private loaderService: LoaderService,
		private layoutUtilsService: LayoutUtilsService,
		public dialogRef: MatDialogRef<ModalCropPlateRecognitionDialogComponent>,
		@Inject(MAT_DIALOG_DATA) public data: ViewDialogData) {
		// console.log('ModalGalleryDialogComponent', data);
		this.dataTypeDisplay = this.translate.instant('Image');
		this.dataTypeSingleDisplay = this.translate.instant('Image');
		this.dataTypeDisplayFolder = this.translate.instant('Folder');

		this.cameras = data.cameras;
	}

	ngOnInit() {
		this.subscriptions.push(
			this.requestService.currentUserSubject.subscribe((data) => {
				if (data) {
					this.selectedUser = data;
				}
			})
		);
	}
	public rationChanged(event) {
		this.selectedRatio = Number(event.value);
	}
	/**
	 * On Destroy
	 */
	ngOnDestroy() {
		this.subscriptions.forEach(el => el.unsubscribe());
	}
	public getBase64ImageFromFile(imageUrl) {
		this.getBase64ImageFromURL(imageUrl).subscribe(base64data => {
			// this is the image as dataUrl
			this.imageUrlPath = 'data:image/png;base64,' + base64data;
		},
			err => {
				this.layoutUtilsService.showNotification(this.translate.instant('Error:') + ' ' + this.translate.instant('The image is not accessible'), this.translate.instant('Dismiss'));
			}
		);
	}
	closeModal(data): void {
		this.zone.run(() => {
			this.dialogRef.close(data);
		});
	}
	goToCrop(): void {
		this.zone.run(() => {
			// console.log(this.imageUrlPath);
			this.tabSelected = 1;
		});
	}
	getFilename(url) {
		if (url) {
			var m = url.toString().match(/.*\/(.+?)\./);
			if (m && m.length > 1) {
				return m[1];
			}
		}
		return "";
	}

	onFileSelected(event: Event): void {
		const input = event.target as HTMLInputElement;
		if (input.files && input.files[0]) {
			const file = input.files[0];
			this.plateRecognitionResults = undefined;
			this.plateImageUrl = undefined;
			this.videoLink = undefined;
			this.isVideo = false;
			this.uploadingVideo = false;
			this.videoFileData = undefined;
			const extension = file.name.split('.').pop()?.toLowerCase();
			if (extension === 'mp4') {
				this.isVideo = true;
				this.readFilesVideo(input.files);
			} else {
				const fileSizeMB = file.size / (1024 * 1024);

				if (!extension || !this.allowedExtensions.includes(extension)) {
					this.layoutUtilsService.showNotification(this.translate.instant('The file type is not allowed'), this.translate.instant('Dismiss'));
				} else if (fileSizeMB > 40) {
					this.layoutUtilsService.showNotification(this.translate.instant('Maximum size allowed is') + ' ' + 40 + 'MB', this.translate.instant('Dismiss'));
				}
				else {
					this.convertFileToDataURL(file);
				}
			}
		}
	}

	private convertFileToDataURL(file: File): void {
		const reader = new FileReader();
		reader.onload = () => {
			let currentFile = { error: false, text: file.name.split('.')[0], originalFile: file, source_url: null };
			this.imageUrlPath = reader.result;
			currentFile['originalFile'] = this.dataURLtoFile(this.imageUrlPath, currentFile.text + '.jpg');
			this.imageSelected = currentFile;
			this.pictureLink = this.imageUrlPath;
			// console.log(this.imageUrlPath); 
		};
		reader.readAsDataURL(file);
	}

	onBrowseFiles(target: any): void {
		if (target.files.length > 0) {
			this.plateRecognitionResults = undefined;
			this.plateImageUrl = undefined;
			this.videoLink = undefined;
			this.isVideo = false;
			this.uploadingVideo = false;
			this.videoFileData = undefined;
			let fileExt = target.files[0].name.split('.').pop();
			if (fileExt === 'mp4') {
				this.isVideo = true;
				this.readFilesVideo(target.files);
			} else {
				this.readFiles(target.files);
			}
		}
	}
	/**
	 *  @param files: list of browsed files
	 *  @param index: iterator over browsed images
	 *
	 *  read files browsed by user
	 */
	readFiles(files, index = 0): void {
		let reader = new FileReader();
		if (index in files) {
			let currentFile = { error: false, text: files[index].name.split('.')[0], id: files[index].id, originalFile: files[index], source_url: null };
			let fileExt = files[index].name.split('.').pop();
			const max_size = 5000000;
			const max_height = 600;
			const max_width = 600;
			if (files[index].size > max_size) {
				this.layoutUtilsService.showNotification(this.translate.instant('Maximum size allowed is') + ' ' + max_size / 1000000 + 'MB', this.translate.instant('Dismiss'));
			} else if (this.allowedExtensions.indexOf(fileExt.toLowerCase()) === -1) {
				currentFile.error = true;
				this.layoutUtilsService.showNotification(this.translate.instant('The file type is not allowed'), this.translate.instant('Dismiss'));
			} else {
				this.readFile(files[index], reader, (event) => {
					this.loaderService.display(true);
					var image = new Image();
					this.readImage(event, image, (imgresult) => {
						// console.log('readImage', imgresult);
						var canvas = document.createElement("canvas");
						var context = canvas.getContext("2d");

						var ratio = Math.min(max_width / imgresult.width, max_height / imgresult.height);


						// console.log('ratio', ratio);
						if (imgresult.width < imgresult.width * ratio && imgresult.height < imgresult.height * ratio) {
							canvas.width = imgresult.width;
							canvas.height = imgresult.height;
						} else {
							canvas.width = imgresult.width * ratio;
							canvas.height = imgresult.height * ratio;
						}
						context.drawImage(image,
							0,
							0,
							image.width,
							image.height,
							0,
							0,
							canvas.width,
							canvas.height
						);
						// console.log(canvas.width, canvas.height);
						// console.log(image.width, max_width, image.height, max_height);
						if (canvas.width <= max_width && canvas.height <= max_height) {
							currentFile['originalFile'] = this.dataURLtoFile(canvas.toDataURL("image/png", 0.75), currentFile.text + '.png');
							this.imageUrlPath = canvas.toDataURL("image/png", 0.75);
							this.imageSelected = currentFile;
							this.pictureLink = this.imageUrlPath;
							this.loaderService.display(false);
						} else {
							this.layoutUtilsService.showNotification(this.translate.instant('The image is not well formatted'), this.translate.instant('Dismiss'));
							this.loaderService.display(false);
						}
						// this.continueUpload(currentFile);
					});
				});
			}
		} else {
			this.cdr.detectChanges();
		}
	}
	/**
	 *  @param files: list of browsed files
	 *  @param index: iterator over browsed images
	 *
	 *  read files browsed by user
	 */
	readFilesVideo(files, index = 0): void {
		let reader = new FileReader();
		if (index in files) {
			let currentFile = { error: false, text: files[index].name.split('.')[0], id: files[index].id, originalFile: files[index], source_url: null };
			let fileExt = files[index].name.split('.').pop();
			const max_size = 5000000;
			const max_height = 600;
			const max_width = 600;
			if (files[index].size > max_size) {
				this.layoutUtilsService.showNotification(this.translate.instant('Maximum size allowed is') + ' ' + max_size / 1000000 + 'MB', this.translate.instant('Dismiss'));
			} else if (this.allowedExtensions.indexOf(fileExt.toLowerCase()) === -1) {
				currentFile.error = true;
				this.layoutUtilsService.showNotification(this.translate.instant('The file type is not allowed'), this.translate.instant('Dismiss'));
			} else {
				reader.onload = () => {
					this.videoLink = reader.result;
					this.getDuration(reader.result, (event) => {
						if (event <= 180) { // 3 minutes
							this.videoFileData = currentFile;
							// this.continueUpload(currentFile);
						} else {
							this.layoutUtilsService.showNotification(this.translate.instant('The video is more than 3 minutes'), this.translate.instant('Dismiss'));
						}
					});
				}
				reader.readAsDataURL(files[index]);
			}
		} else {
			this.cdr.detectChanges();
		}
	}
	continueVideoUpload() {
		// this.continueUpload(this.videoFileData);
		this.uploadingVideo = true;
		this.layoutUtilsService.showNotification(this.translate.instant('The video is processiing please wait...'), this.translate.instant('Dismiss'));
		setTimeout(() => {
			this.uploadingVideo = false;
			this.videoLink = undefined;
			this.layoutUtilsService.showNotification(this.translate.instant('No results from the video'), this.translate.instant('Dismiss'));
		}, 6000);
	}
	getDuration(file, callback) {
		const media = new Audio(file);
		media.onloadedmetadata = () => {
			if (media.duration < 1) {
				console.log("Invalid Video! video is less than 1 second");
				return;
			}
			callback(media.duration);
		}
	}
	dataURLtoFile(dataurl, filename) {
		var arr = dataurl.split(','),
			mime = arr[0].match(/:(.*?);/)[1],
			bstr = atob(arr[1]),
			n = bstr.length,
			u8arr = new Uint8Array(n);

		while (n--) {
			u8arr[n] = bstr.charCodeAt(n);
		}

		return new File([u8arr], filename, { type: mime });
	}
	readFileAsArrayBuffer(file, reader, callback): void {
		reader.onload = () => {
			callback(reader.result);
		}
		reader.readAsArrayBuffer(file);
	}
	readFile(file, reader, callback): void {
		reader.onload = () => {
			callback(reader.result);
		}
		reader.readAsDataURL(file);
	}
	readImage(file, image, callback): void {
		image.onload = () => {
			callback(image);
		}
		image.src = file;
	}
	continueUpload(currentFile) {
		if (!this.loading && currentFile && currentFile.originalFile) {
			this.loading = true;
			this.loaderService.display(true);
			this.errorMessage = '';
			this.requestService.onUploadCarplateImage(currentFile)
				.subscribe(
					(results: any) => {
						// console.log('results', results);
						if (results['status']) {
							// currentFile.source_url = results.results.pictureLink;
							// this.pictureLink = results.results.pictureLink;
							// this.layoutUtilsService.showNotification(this.translate.instant('User image uploaded successfully'), this.translate.instant('Dismiss'));

							this.loading = false;
							this.plateRecognitionResults = [];

							if (results.results.data.vehicles.length == 0)
								this.isEmpty = true;
							else
								this.isEmpty = false;

							results.results.data.vehicles.forEach(car => {
								let vehicle: any = {
									en: {
										plate: car.plate.unicodeText,
										region: car.plate.country,
										type: car.mmr.bodyType,
										model: car.mmr.model,
										make: car.mmr.make,
										color: car.mmr.colorName,
										orientation: car.mmr.heading,
									},
									jp: {
										plate: car.plate.unicodeText,
										region: car.region,
										type: car.type,
										model: car.model,
										make: car.mmr.make,
										color: car.color,
										orientation: car.orientation,
									},
								};

								if (this.requestService.lang == 'ja') {
									vehicle.display = vehicle.jp;
								}
								else {
									vehicle.display = vehicle.en;
								}

								// if (plate.model_make?.length) {
								// 	vehicle.model = plate.model_make[0].model;
								// 	vehicle.make = plate.model_make[0].make;
								// }

								// if (plate.color?.length) {
								// 	vehicle.color = plate.color[0].color;
								// }

								// if (plate.orientation?.length) {
								// 	vehicle.orientation = plate.orientation[0].orientation;
								// }

								vehicle.originalResult = car;

								this.plateRecognitionResults.push(vehicle);
							});

							this.plateImageUrl = results.results.filename;

							// if (results.results.results.length == 0)
							// 	this.isEmpty = true;
							// else
							// 	this.isEmpty = false;

							// results.results.results.forEach(plate => {
							// 	let vehicle: any = {
							// 		plate: plate.plate,
							// 		region: plate.region.code,
							// 		type: plate.vehicle.type,
							// 	};

							// 	if (plate.model_make?.length) {
							// 		vehicle.model = plate.model_make[0].model;
							// 		vehicle.make = plate.model_make[0].make;
							// 	}

							// 	if (plate.color?.length) {
							// 		vehicle.color = plate.color[0].color;
							// 	}

							// 	if (plate.orientation?.length) {
							// 		vehicle.orientation = plate.orientation[0].orientation;
							// 	}

							// 	vehicle.originalResult = plate;

							// 	this.plateRecognitionResults.push(vehicle);
							// });

							// this.plateImageUrl = results.results.filename;
							this.imageSelected = undefined;
							this.loaderService.display(false);
							// this.closeModal(results.results.pictureLink);
						} else {
							this.loading = false;
							currentFile.error = true;
							this.loaderService.display(false);
							this.layoutUtilsService.showNotification(this.translate.instant('Error:') + results['message'], this.translate.instant('Dismiss'));
						}
						this.imageInput.nativeElement.value = '';
						this.cdr.detectChanges();
					},
					(error: any) => {
						// console.log('Error uploading file.', error);
						this.loading = false;
						currentFile.error = true;
						this.loaderService.display(false);
						this.layoutUtilsService.showNotification(this.translate.instant('Error:') + ' ' + this.translate.instant('Uploading') + ' ' + this.translate.instant('file'), this.translate.instant('Dismiss'));
						this.cdr.detectChanges();
					}
				);
		} else {
			this.closeModal(undefined);
		}
	}
	// fileChangeEvent(event: any): void {
	//     this.imageChangedEvent = event;
	// }
	cropIt() {
		let croppedImage = this.imageCropper.crop();
		if (!this.loading && this.imageSelected && croppedImage) {
			this.imageSelected['originalFile'] = this.dataURLtoFile(croppedImage.base64, this.imageSelected.text + '.png');
			this.continueUpload(this.imageSelected);
		}
	}

	recognize() {
		if (!this.loading && this.imageSelected) {
			this.imageSelected['originalFile'] = this.dataURLtoFile(this.imageUrlPath, this.imageSelected.text + '.jpg');
			this.continueUpload(this.imageSelected);
		}
	}

	imageCropped(event: ImageCroppedEvent) {
		this.croppedImage = event.base64;
	}
	imageHasLoaded(e) {
		//  console.log('imageHasLoaded', e);
	}
	imageLoaded() {
		// show cropper
	}
	cropperReady() {
		// cropper ready
	}
	loadImageFailed() {
		// show message
	}
	// public clearIt(e) {
	// 	if (e) {
	// 		e.stopImmediatePropagation();
	// 		e.preventDefault();
	// 		// e.stopPropagation();
	// 	}
	// 	if (!this.loading) {
	// 		const _title: string = this.translate.instant(this.dataTypeDisplay) + ' ' + this.translate.instant('Deletion');
	// 		const _description: string = this.translate.instant('Are you sure you want to permanently delete this') + ' ' + this.dataTypeDisplay + '?';
	// 		const _waitDesciption: string = this.translate.instant('Deleting') + '...';

	// 		const dialogRef = this.layoutUtilsService.deleteElement(_title, _description, _waitDesciption);
	// 		dialogRef.afterClosed().subscribe(res => {
	// 			if (!res) {
	// 				return;
	// 			}
	// 			this.realDelete();
	// 		});
	// 	}
	// }
	// public realDelete() {
	// 	const _deleteMessage = this.dataTypeDisplay + ' ' + this.translate.instant('Deleted Successfully') ;
	// 	// this.layoutUtilsService.showNotification(_deleteMessage,  this.translate.instant('Dismiss'));
	// 	if (!this.loading) {
	// 		this.loading = true;
	// 		this.errorMessage = '';
	// 		this.requestService.deleteProfileImage('user', this.targetUserId, (data, error) => {
	// 			if (error) {
	// 				this.errorMessage = error;
	// 				this.layoutUtilsService.showNotification(this.translate.instant('Error:') + error, this.translate.instant('Dismiss'));
	// 			}
	// 			this.loading = false;
	// 			if (data) {
	// 				this.layoutUtilsService.showNotification(_deleteMessage, this.translate.instant('Dismiss'));
	// 				this.imageSelected = undefined;
	// 				this.imageUrlPath = undefined;
	// 				this.pictureLink = undefined;

	// 				// this.closeModal(this.defaultPictureLink);
	// 			}
	// 		});
	// 	}
	// }

	getBase64ImageFromURL(url: string) {
		return Observable.create((observer: Observer<string>) => {
			// create an image object
			let img = new Image();
			img.crossOrigin = 'Anonymous';
			img.src = url + '?t=' + new Date().getTime();
			if (!img.complete) {
				// This will call another method that will create image from url
				img.onload = () => {
					observer.next(this.getBase64Image(img));
					observer.complete();
				};
				img.onerror = (err) => {
					observer.error(err);
				};
			} else {
				observer.next(this.getBase64Image(img));
				observer.complete();
			}
		});
	}

	getBase64Image(img: HTMLImageElement) {
		// We create a HTML canvas object that will create a 2d image
		var canvas = document.createElement("canvas");
		canvas.width = img.width;
		canvas.height = img.height;
		var ctx = canvas.getContext("2d");
		// This will draw image
		ctx.drawImage(img, 0, 0);
		// Convert the drawn image to Data URL
		var dataURL = canvas.toDataURL("image/png", 0.75);
		return dataURL.replace(/^data:image\/(png|jpg|jpeg);base64,/, "");
	}

	addToDatabase(result, index) {
		if (!this.loading) {
			this.loading = true;
			this.loaderService.display(true);
			this.requestService.generatePlate(this.plateImageUrl, [result], this.selectedCamera, (data, error) => {
				if (error) {
					this.errorMessage = error;
					this.layoutUtilsService.showNotification(this.translate.instant('Error: ') + error, this.translate.instant('Dismiss'));
				}
				this.loading = false;
				this.loaderService.display(false);
				if (data && this.plateRecognitionResults[index]) {
					this.plateRecognitionResults.splice(index, 1);
					this.layoutUtilsService.showNotification(this.translate.instant('Added plate successfully'), this.translate.instant('Dismiss'));
				}
			});
		}
	}

	edit(index) {
		this.plateRecognitionResults[index].editable = !this.plateRecognitionResults[index].editable;
	}
}
